const riveHandObject = {
    instance: null,
    status: -1,
    container: null,
    initialize: function () {
        if (this.status === -1) {
            this.status = 0;

            this.container = document.querySelector('.rive-hand');
            const elmPhone = document.getElementById('rive-hand_canvas');
            elmPhone.setAttribute('width', Math.ceil(window.innerHeight * 0.54718).toString());
            elmPhone.setAttribute('height', window.innerHeight.toString());

            this.instance = new rive.Rive({
                src: document.location.origin + '/i/instaforex/rive/mockup_section2.riv',
                canvas: elmPhone,
                artboard: 'mockup_section2',
                stateMachines: 'state',
                layout: new rive.Layout({
                    fit: rive.Fit.Contain,
                    alignment: rive.Alignment.Center
                }),
                autoplay: true,
                onload: function () {
                    //riveObject.play();
                    this.status = 1;
                    main.setLoaderPercent(1);
                }.bind(this),
            });

            this.reactToResize();

            //this.status = 1;
        }
    },
    play: function () {
        this.container.style.opacity = '1';
        this.instance.play();
    },
    pause: function () {
        this.container.style.opacity = '0';
        this.instance.pause();
    },
    fire: function (id) {
        const inputs = this.instance.stateMachineInputs('state');
        if (typeof inputs !== 'undefined' && typeof inputs[id] !== 'undefined') this.instance.stateMachineInputs('state')[id].fire();
    },
    setBorderRadius: function () {
        this.container.style.borderRadius = Math.round((this.container.clientWidth / 100) * 15) + 'px';
    },
    reactToResize: function () {
        this.setBorderRadius();
    }
};
